module.exports = __webpack_public_path__ + "media/images/icons/outlined/dislike-7c9aeaa805b3cb3d7caea380c75b55bb.svg";